<template>
  <div class="mb-5">
    <div class="row">
      <label class="col-4">{{ $t("CONTENT.assets.lease_end_date") }}:</label>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <span class="b-contract__secondary-text">{{ $t("CONTENT.assets.lease_end_date_description") }}</span>
        <dynamic-icon
          class="ml-1 b-asset__icon-question"
          v-tooltip="$t('CONTENT.hints.endDateEventHint')"
          icon="question"
        ></dynamic-icon>
      </div>
    </div>
    <div class="row">
      <datepicker class="col-4 b-datepicker" v-model="newEndDate" :formatter="datepickerFormat"></datepicker>
    </div>
  </div>
</template>

<script>
import ChangeRentDuration from "../../models/commands/ChangeRentDuration";
import dateConverter from "@/utils/converters/date.converter";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  components: {},
  props: {
    assetComponent: {
      type: Object,
      required: true
    },
    endDate: {
      type: String,
      required: true
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      newEndDateAsString: null
    };
  },
  computed: {
    newEndDate: {
      get() {
        if (this.newEndDateAsString === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.newEndDateAsString);
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.newEndDateAsString = dateConverter.convertToString(newVal);
        } else {
          this.newEndDateAsString = null;
        }
      }
    }
  },
  created() {
    this.newEndDateAsString = this.endDate;
  },
  methods: {
    cancel() {
      this.newEndDateAsString = this.endDate;
    },

    save() {
      const command = new ChangeRentDuration(this.assetComponent.idInDB, this.newEndDateAsString);
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style></style>
